(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-now-with-price"] && !Shopify.designMode) return;
  try {
    // Fallback money formatter if Shopify.formatMoney is not available
  function formatMoneyBuyNow(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, format);
      } catch(e) {
        console.warn('Shopify.formatMoney failed:', e);
      }
    }
    
    // Simple fallback formatter
    const amount = (cents / 100).toFixed(2);
    const amountNoDecimals = Math.round(cents / 100).toString();
    const amountWithComma = amount.replace('.', ',');
    
    // Use format if provided, otherwise try to detect currency
    let result = format || amount;
    
    if (format) {
      result = format
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma);
    }
    
    // If result is just the number (no currency symbol), try to get currency from page
    if (!result.match(/[^\d\s.,]/)) {
      let currencySymbol = null;
      
      // Try Shopify currency object
      if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
        const currencyMap = {
          'USD': '$', 'EUR': '€', 'GBP': '£', 'JPY': '¥', 'CAD': 'C$', 'AUD': '$',
          'CHF': 'CHF', 'CNY': '¥', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'PLN': 'zł',
          'RUB': '₽', 'INR': '₹', 'BRL': 'R$', 'ZAR': 'R', 'MXN': '$', 'KRW': '₩'
        };
        currencySymbol = currencyMap[Shopify.currency.active] || Shopify.currency.active;
      }
      
      // Try to extract from existing price on page
      if (!currencySymbol) {
        const existingPrice = document.querySelector('.price:not(.forge-bundle-price-display .price), .price-item, .product__price');
        if (existingPrice && existingPrice.textContent) {
          const priceText = existingPrice.textContent.trim();
          const currencyMatch = priceText.match(/^([^\d\s.,]+)|([^\d\s.,]+)$/);
          if (currencyMatch) {
            currencySymbol = currencyMatch[1] || currencyMatch[2];
          }
        }
      }
      
      if (currencySymbol) {
        result = currencySymbol + result;
      }
    }
    
    return result;
  }

  class BuyNowWithPriceButton extends HTMLElement {
    constructor() {
      super();
      this.bundleQuantity = null;
      this.originalPrice = null;
    }

    connectedCallback() {
      const button = this.querySelector('[ref="buyNowButton"]');
      if (!button) return;

      button.addEventListener('click', this.handleBuyNow.bind(this));

      // Listen for variant changes to update price
      const closestSection = this.closest('.shopify-section');
      if (closestSection) {
        closestSection.addEventListener('variant:update', this.updatePrice);
      }

      // Listen for bundle selection events
      document.addEventListener('forge:bundleSelected', this.handleBundleSelection);

      // Store original price for reference
      const priceElement = this.querySelector('[ref="buttonPrice"]');
      if (priceElement) {
        this.originalPrice = priceElement.textContent;
      }

      // Check if there's already a bundle selection
      if (window.forgeBundleSelection) {
        this.handleBundleSelection({ detail: window.forgeBundleSelection });
      }

      // Setup auto-wiggle if enabled
      this.setupAutoWiggle();
    }

    disconnectedCallback() {
      const closestSection = this.closest('.shopify-section');
      if (closestSection) {
        closestSection.removeEventListener('variant:update', this.updatePrice);
      }
      document.removeEventListener('forge:bundleSelected', this.handleBundleSelection);

      // Clear auto-wiggle interval
      if (this.wiggleInterval) {
        clearInterval(this.wiggleInterval);
      }
    }

    setupAutoWiggle() {
      const autoWiggleInterval = this.getAttribute('data-auto-wiggle-interval');
      
      if (!autoWiggleInterval || autoWiggleInterval === 'off') return;

      const intervalSeconds = parseInt(autoWiggleInterval);
      const button = this.querySelector('.buy-now-with-price__button');
      
      if (!button) return;

      // Start the auto-wiggle interval
      this.wiggleInterval = setInterval(() => {
        if (button.disabled) return;
        
        button.classList.add('auto-wiggle');
        
        // Remove the class after animation completes (600ms)
        setTimeout(() => {
          button.classList.remove('auto-wiggle');
        }, 600);
      }, intervalSeconds * 1000);
    }

    handleBundleSelection = (event) => {
      const { quantity, discountedTotal } = event.detail;
      
      // Store bundle quantity
      this.bundleQuantity = quantity;

      // Update displayed price to bundle total (use >= 0 to handle free items)
      const priceElement = this.querySelector('[ref="buttonPrice"]');
      if (priceElement && typeof discountedTotal === 'number' && discountedTotal >= 0) {
        const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : null;
        const formattedPrice = formatMoneyBuyNow(discountedTotal, moneyFormat);
        priceElement.textContent = formattedPrice;
        
        // Add visual indicator that this is a bundle price
        priceElement.classList.add('bundle-price-active');
      }

      // Store bundle data as data attributes on the button
      const button = this.querySelector('.buy-now-with-price__button');
      if (button) {
        button.dataset.bundleQuantity = quantity;
        button.dataset.bundlePrice = discountedTotal;
        button.dataset.bundleActive = 'true';
      }
    };

    handleBuyNow(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const button = event.currentTarget;
      if (button.disabled) return;

      // Get the variant ID from the form
      const form = this.closest('form');
      if (!form) return;
      
      const variantIdInput = form.querySelector('[name="id"]');
      const variantId = variantIdInput ? variantIdInput.value : null;

      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Priority order for getting quantity:
      // 1. Bundle selection (from our bundle block)
      // 2. Data attribute on button (set by bundle selection)
      // 3. Global bundle selection object
      // 4. Form quantity input
      // 5. External quantity inputs
      // 6. Default to 1
      
      let quantity = 1;
      
      // Check bundle selection first (highest priority)
      if (this.bundleQuantity && this.bundleQuantity > 0) {
        quantity = this.bundleQuantity;
      } else if (button.dataset.bundleQuantity) {
        quantity = parseInt(button.dataset.bundleQuantity) || 1;
      } else if (window.forgeBundleSelection && window.forgeBundleSelection.quantity) {
        quantity = window.forgeBundleSelection.quantity;
      } else {
        // Fall back to traditional quantity input discovery
        const quantitySelectors = [
          '[name="quantity"]',
          '.quantity-selector input',
          '.quantity__input',
          '[data-quantity-input]',
          '.product-form__quantity input'
        ];
        
        // Try current form first
        for (const selector of quantitySelectors) {
          const input = form.querySelector(selector);
          if (input && input.value) {
            quantity = parseInt(input.value) || 1;
            break;
          }
        }
        
        // If still 1, try broader search
        if (quantity === 1) {
          const mainProductForm = document.querySelector('form[id^="BuyButtons-ProductForm-"]');
          if (mainProductForm) {
            const mainQuantityInput = mainProductForm.querySelector('input[name="quantity"]');
            if (mainQuantityInput) {
              quantity = parseInt(mainQuantityInput.value) || 1;
            }
          }
        }
        
        // Final fallback: any quantity input on page
        if (quantity === 1) {
          for (const selector of quantitySelectors) {
            const input = document.querySelector(selector);
            if (input && input.value) {
              quantity = parseInt(input.value) || 1;
              break;
            }
          }
        }
        
        // Check bundle wrapper data attributes as last resort
        if (quantity === 1) {
          const bundleWrapper = document.querySelector('.forge-bundle-wrapper');
          if (bundleWrapper && bundleWrapper.dataset.selectedQuantity) {
            quantity = parseInt(bundleWrapper.dataset.selectedQuantity) || 1;
          }
        }
      }

      // Disable button and show loading state
      button.disabled = true;
      const originalText = button.innerHTML;
      button.innerHTML = '<span class="buy-now-with-price__content">Processing...</span>';

      // Add item to cart via AJAX, then redirect to checkout
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // Redirect to checkout
          window.location.href = '/checkout';
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          // Re-enable button on error
          button.disabled = false;
          button.innerHTML = originalText;
          alert('Unable to add item to cart. Please try again.');
        });
    }

    updatePrice = (event) => {
      if (event.detail.data?.newProduct) {
        const productFormComponent = this.closest('product-form-component');
        if (productFormComponent) productFormComponent.dataset.productId = event.detail.data.newProduct.id;
      } else {
        const productFormComponent = this.closest('product-form-component');
        if (productFormComponent && event.detail.data?.productId !== productFormComponent.dataset.productId) return;
      }

      // Skip if we have an active bundle selection
      if (this.bundleQuantity && window.forgeBundleSelection) {
        // Recalculate bundle price with new variant price
        const newVariantPrice = event.detail?.resource?.price;
        if (newVariantPrice && window.forgeBundleSelection) {
          const bundle = window.forgeBundleSelection;
          // Update unit price and recalculate
          const newDiscountedTotal = (newVariantPrice / bundle.unitPrice) * bundle.discountedTotal;
          
          const priceElement = this.querySelector('[ref="buttonPrice"]');
          if (priceElement) {
            const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : null;
            priceElement.textContent = formatMoneyBuyNow(newDiscountedTotal, moneyFormat);
          }
        }
        return;
      }

      const priceElement = this.querySelector('[ref="buttonPrice"]');
      if (!priceElement) return;

      // Get the new price from the variant
      if (event.detail && event.detail.resource && event.detail.resource.price) {
        const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : null;
        const newPrice = formatMoneyBuyNow(event.detail.resource.price, moneyFormat);
        priceElement.textContent = newPrice;
      }
    };
  }

  if (!customElements.get('buy-now-with-price-button')) {
    customElements.define('buy-now-with-price-button', BuyNowWithPriceButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-info"] && !Shopify.designMode) return;
  try {
    class DeliveryInfo extends HTMLElement {
    constructor() {
      super();
      const container = this.querySelector('.delivery-info');
      const data = container ? container.dataset : this.dataset;
      
      this.cutoffHour = parseInt(data.cutoffHour) || 14;
      this.processingMin = parseInt(data.processingMin) || 1;
      this.processingMax = parseInt(data.processingMax) || 2;
      this.shippingMin = parseInt(data.shippingMin) || 3;
      this.shippingMax = parseInt(data.shippingMax) || 5;
      this.includeWeekends = data.includeWeekends === 'true';
      
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.deliveryDatesEl = this.querySelector('[data-delivery-dates]');
      this.orderedDateEl = this.querySelector('[data-ordered-date]');
      this.shippedDateEl = this.querySelector('[data-shipped-date]');
      this.deliveredDateEl = this.querySelector('[data-delivered-date]');
      
      this.init();
    }

    init() {
      this.updateCountdown();
      this.updateDates();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
      const now = new Date();
      let cutoff = new Date();
      cutoff.setHours(this.cutoffHour, 0, 0, 0);
      
      // If past cutoff, set to tomorrow
      if (now >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
      }
      
      const diff = cutoff - now;
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
    }

    updateDates() {
      const now = new Date();
      const cutoff = new Date();
      cutoff.setHours(this.cutoffHour, 0, 0, 0);
      
      // If past cutoff, order ships tomorrow
      let orderDate = new Date(now);
      if (now >= cutoff) {
        orderDate.setDate(orderDate.getDate() + 1);
      }
      
      // Shipped date range (after processing days)
      // If processingMin is 0, it can ship on orderDate
      let shippedStart = this.addBusinessDays(orderDate, this.processingMin);
      let shippedEnd = this.addBusinessDays(orderDate, this.processingMax);

      // Delivered date range (after shipping)
      let deliveredStart = this.addBusinessDays(shippedStart, this.shippingMin);
      let deliveredEnd = this.addBusinessDays(shippedEnd, this.shippingMax);
      
      // Update elements
      if (this.deliveryDatesEl) {
        this.deliveryDatesEl.textContent = `${this.formatDate(deliveredStart)} - ${this.formatDate(deliveredEnd)}`;
      }
      
      if (this.orderedDateEl) {
        this.orderedDateEl.textContent = this.formatDate(orderDate);
      }
      
      if (this.shippedDateEl) {
        // Show shipped date range
        if (this.processingMin === this.processingMax) {
          // Same day if processing range is single day
          this.shippedDateEl.textContent = this.formatDate(shippedStart);
        } else {
          // Show range if processing days vary
          this.shippedDateEl.textContent = `${this.formatDate(shippedStart)} - ${this.formatDate(shippedEnd)}`;
        }
      }
      
      if (this.deliveredDateEl) {
        this.deliveredDateEl.textContent = `${this.formatDate(deliveredStart)} - ${this.formatDate(deliveredEnd)}`;
      }
    }

    addBusinessDays(date, days) {
      let result = new Date(date);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        // Skip weekends only if includeWeekends is false (business days only)
        if (this.includeWeekends || (result.getDay() !== 0 && result.getDay() !== 6)) {
          added++;
        }
      }
      return result;
    }

    formatDate(date) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${months[date.getMonth()]} ${date.getDate().toString().padStart(2, '0')}`;
    }

    pad(num) {
      return num.toString().padStart(2, '0');
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  customElements.define('delivery-info', DeliveryInfo);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    class ImageBounceBlock extends HTMLElement {
    connectedCallback() {
      this.setupAutoBounce();
    }

    disconnectedCallback() {
      if (this.bounceInterval) {
        clearInterval(this.bounceInterval);
      }
    }

    setupAutoBounce() {
      const autoBounceInterval = this.getAttribute('data-auto-bounce-interval');
      
      if (!autoBounceInterval || autoBounceInterval === 'off') return;

      const intervalSeconds = parseInt(autoBounceInterval);
      const speed = this.getAttribute('data-bounce-speed') || 'normal';
      
      // Get animation duration based on speed (faster overall)
      const durations = { slow: 600, normal: 400, fast: 250 };
      const animationDuration = durations[speed] || 400;
      
      // Start the auto-bounce interval
      this.bounceInterval = setInterval(() => {
        this.classList.add('bouncing');
        
        // Remove the class after animation completes
        setTimeout(() => {
          this.classList.remove('bouncing');
        }, animationDuration);
      }, intervalSeconds * 1000);
    }
  }

  if (!customElements.get('image-bounce-block')) {
    customElements.define('image-bounce-block', ImageBounceBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["low-stock-indicator"] && !Shopify.designMode) return;
  try {
    class LowStockIndicator extends HTMLElement {
    connectedCallback() {
      this.hiddenClass = this.dataset.hiddenClass;
      this.blockId = this.dataset.blockId;
      this.closestSection = this.closest('.shopify-section, dialog');

      this.onVariantUpdate = (event) => {
        const html = event?.detail?.data?.html;
        if (!html) return;

        const updatedBlock = html.querySelector(`low-stock-indicator[data-block-id="${this.blockId}"]`);
        if (!updatedBlock) return;

        const nextCount = updatedBlock.querySelector('[data-stock-count]');
        const currentCount = this.querySelector('[data-stock-count]');

        if (nextCount && currentCount) {
          currentCount.textContent = nextCount.textContent;
        }

        const shouldHide = updatedBlock.classList.contains(this.hiddenClass);
        this.classList.toggle(this.hiddenClass, shouldHide);
      };

      this.closestSection?.addEventListener('variant:update', this.onVariantUpdate);
    }

    disconnectedCallback() {
      this.closestSection?.removeEventListener('variant:update', this.onVariantUpdate);
    }
  }

  if (!customElements.get('low-stock-indicator')) {
    customElements.define('low-stock-indicator', LowStockIndicator);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["urgency-timer"] && !Shopify.designMode) return;
  try {
    class UrgencyTimer extends HTMLElement {
    constructor() {
      super();
      this.countdown = this.querySelector('.urgency-timer__countdown');
      this.daysElement = this.countdown.querySelector('[data-days]');
      this.hoursElement = this.countdown.querySelector('[data-hours]');
      this.minutesElement = this.countdown.querySelector('[data-minutes]');
      this.secondsElement = this.countdown.querySelector('[data-seconds]');
      this.totalHours = parseInt(this.countdown.dataset.hours) || 24;

      this.initTimer();
    }

    initTimer() {
      // Check if timer exists in localStorage
      let endTime = localStorage.getItem('urgency_timer_end');
      
      if (!endTime || new Date(parseInt(endTime)) < new Date()) {
        // Create new timer
        endTime = new Date().getTime() + (this.totalHours * 60 * 60 * 1000);
        localStorage.setItem('urgency_timer_end', endTime);
      }
      
      this.endTime = parseInt(endTime);
      this.updateTimer();
      this.interval = setInterval(() => this.updateTimer(), 1000);
    }

    updateTimer() {
      const now = new Date().getTime();
      const distance = this.endTime - now;

      if (distance < 0) {
        // Reset timer
        this.endTime = new Date().getTime() + (this.totalHours * 60 * 60 * 1000);
        localStorage.setItem('urgency_timer_end', this.endTime);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (this.daysElement) this.daysElement.textContent = this.pad(days);
      this.hoursElement.textContent = this.pad(hours);
      this.minutesElement.textContent = this.pad(minutes);
      this.secondsElement.textContent = this.pad(seconds);
    }

    pad(num) {
      return num.toString().padStart(2, '0');
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }

  customElements.define('urgency-timer', UrgencyTimer);
  } catch(e) { console.error(e); }
})();

})();
